import React from 'react';
import { createUseStyles } from 'react-jss';
import { Theme } from '@app/theme';
import { Participation } from '@app/api';
import { BookedParticipationCard } from '../../Home/components/BookedParticipationCard';
import { EmptyState } from './EmptyState';
import Calendar from '@app/illu/Small/Calendar.svg';
import { StudiesCardContainer } from './StudiesCardContainer';
import { useTranslation } from 'react-i18next';

const useStyles = createUseStyles((theme: Theme) => ({
  cardContainer: {
    width: '100%',
    maxWidth: theme.maxContentWidth.reduced,
    minWidth: 'auto',
    overflow: 'hidden',
    borderRadius: theme.borderRadius.large,
    marginBottom: theme.marginBase,
    [theme.media.homeScreen]: {
      width: '100%',
      minWidth: 'auto',
    },
  },
}));

interface Props {
  participations: Participation[];
}

export const StudiesConfirmed = ({ participations }: Props) => {
  const classes = useStyles();
  const { t } = useTranslation();

  const noParticipation = !participations || participations.length === 0;

  return (
    <StudiesCardContainer noParticipation={noParticipation}>
      {noParticipation ? (
        <EmptyState
          illustration={Calendar}
          alt="Calendar"
          title={t('studies.empty.confirmed.title')}
          description={t('studies.empty.confirmed.description')}
        />
      ) : (
        participations.map((participation, num) => {
          return (
            <BookedParticipationCard
              key={participation.id}
              participation={participation}
              className={classes.cardContainer}
              variant={num === 0 ? 'plain' : 'transparent'}
            />
          );
        })
      )}
    </StudiesCardContainer>
  );
};
